import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=37b21c47&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b21c47')) {
      api.createRecord('37b21c47', component.options)
    } else {
      api.reload('37b21c47', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=37b21c47&", function () {
      api.rerender('37b21c47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/components/logo.vue"
export default component.exports